
<div :class="['search', { active, disabled, 'menu-open': showMenu, global, header }]">
  <dropdown
    flex
    :active="active"
    @close="handleClose"
  >
    <div class="input" @click.stop.prevent="tryActivate">
      <icon name="search" class="search-icon" />

      <input
        ref="input"
        v-model="query"
        type="search"
        maxlength="10000"
        :placeholder="placeholder"
        @focus.stop.prevent="tryActivate"
        @keyup.up.prevent="handleUp"
        @keyup.down.prevent="handleDown"
        @keyup.enter.prevent="handleEnter"
      />
    </div>

    <template #menu>
      <div class="dropdown-menu">
        <div v-if="global" v-show="!showRecentGlobalSearches">
          <slot name="header" />
        </div>

        <div v-show="searching && items.length === 0" class="loading-container">
          <spinner inline />
        </div>

        <div v-show="showRecentGlobalSearches" class="recent-searches">
          <div
            v-for="(recentSearch, i) in recentGlobalSearches"
            :key="i"
            class="item"
            @click="handleSelectRecentSearch(recentSearch)"
          >
            <align small-gap justify="space-between" class="recent-search">
              <span>{{ recentSearch }}</span>

              <icon-button size="18" icon="close" @click.stop="deleteRecentGlobalSearch(i)" />
            </align>
          </div>
        </div>

        <div v-show="showNoResults" class="no-results">
          <span>No results</span>
        </div>

        <div
          v-for="(item, i) in options"
          ref="items"
          :key="item.id"
          :class="['item', { highlight: i === arrowCounter }]"
          @click.stop.prevent="handleSelect(item)"
          @mouseover.prevent="arrowCounter = -1"
        >
          <slot :item="item" :source="source">
            {{ item.label }}
          </slot>
        </div>
      </div>
    </template>
  </dropdown>
</div>
